import _ from '@lodash';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import FuseLoading from '@fuse/core/FuseLoading';
import { ThemeProvider } from '@material-ui/core/styles';
import { useState } from 'react';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useFormContext } from 'react-hook-form';
import { Button, Icon, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import HysysModelEditService from '../service/HysysModelEditService';

const INPUT_ATTRIBUTES_FIELD = 'inputAttributes';
const OUTPUT_ATTRIBUTES_FIELD = 'outputAttributes';

const fillWithNull = obj => {
	const result = { ...obj };
	Object.keys(result).forEach(key => {
		result[key] = null;
	});
	return result;
};

function LoadHysysAttributeInfoButton(props) {
	const { id } = props;
	const { t } = useTranslation(['model', 'common']);
	const mainTheme = useSelector(selectMainTheme);
	const dispatch = useDispatch();
	const { getValues, setValue } = useFormContext();
	const [loading, setLoading] = useState(false);
	const [showDialog, setShowDialog] = useState(false);
	const [message, setMessage] = useState([]);

	const handleClick = () => {
		// const modelName = getValues('name');
		if (id == null) {
			dispatch(showMessage({ message: 'Model is required.' }));
		} else {
			setLoading(true);
			setShowDialog(true);
			setMessage([]);
			HysysModelEditService.getHysysAttributeInfo(id)
				.then(response => handleResponse(response))
				.catch(err => handleCatch(err));
		}
	};

	const handleResponse = data => {
		console.log(data);
		if (data != null && _.isObject(data)) {
			let inputChangedCount = 0;
			let outputChangedCount = 0;

			if (_.isObject(data.input_attributes)) {
				const inputAttributes = data.input_attributes;
				const newInputs = (getValues(INPUT_ATTRIBUTES_FIELD) || []).map(input => {
					if (input == null || !Object.prototype.hasOwnProperty.call(inputAttributes, input.name)) {
						return input;
					}

					const value = inputAttributes[input.name];
					inputChangedCount += 1;

					if (_.isObject(value)) {
						return {
							...input,
							value,
							minValue: fillWithNull(value),
							maxValue: fillWithNull(value)
						};
					}

					return {
						...input,
						value,
						minValue: null,
						maxValue: null
					};
				});

				if (inputChangedCount > 0) {
					setValue(INPUT_ATTRIBUTES_FIELD, newInputs, { shouldDirty: true, shouldValidate: true });
					console.log(newInputs);
				}
			}

			if (_.isObject(data.output_attributes)) {
				const newOutputs = [...(getValues(OUTPUT_ATTRIBUTES_FIELD) || [])];
				Object.keys(data.output_attributes).forEach(attributeName => {
					const index = newOutputs.findIndex(outp => outp.name === attributeName);
					if (index > -1) {
						if (_.isArray(data.output_attributes[attributeName])) {
							if (newOutputs[index].components == null || (_.isArray(newOutputs[index].components) && newOutputs[index].components.length === 0)) {
								newOutputs[index] = {
									...newOutputs[index],
									components: data.output_attributes[attributeName]
								};
								outputChangedCount += 1;
							}
						}
					}
				});
				if (outputChangedCount > 0) {
					setValue(OUTPUT_ATTRIBUTES_FIELD, newOutputs, { shouldDirty: true, shouldValidate: true });
				}
			}

			if (inputChangedCount > 0 || outputChangedCount > 0) {
				dispatch(showMessage({ message: `Attribute info loaded. Input attributes updated: ${inputChangedCount}` }));
			} else {
				dispatch(showMessage({ message: 'Attribute info loaded, but no matching attributes found.' }));
			}
			setShowDialog(false);
		} else if (_.isString(data)) {
			setMessage([data || 'Empty result']);
		}
		setLoading(false);
	};

	const handleCatch = err => {
		console.log(err);
		setLoading(false);
		setMessage([`Connection problem: ${err !== null ? err : 'Unknown'}`]);
	};

	return (
		<>
			<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" disabled={id === 'new'} onClick={() => handleClick()} startIcon={<Icon className="hidden sm:flex">graphic_eq</Icon>}>
				{t('loadValues')}
			</Button>
			<ThemeProvider theme={mainTheme}>
				<Dialog open={showDialog} fullWidth>
					<DialogTitle disableTypography className="border-b">
						{t('loadValues')}
					</DialogTitle>
					<DialogContent className="p-20">
						{loading && <FuseLoading />}
						{!loading && message.length > 0 && message.map(mess => <div className="flex py-8">{mess}</div>)}
						{!loading && message.length === 0 && <div className="flex justify-center">No result</div>}
					</DialogContent>
					<DialogActions className="justify-between border-t p-20">
						<Button
							onClick={() => {
								setShowDialog(false);
							}}
						>
							{t('common:close')}
						</Button>
					</DialogActions>
				</Dialog>
			</ThemeProvider>
		</>
	);
}
export default LoadHysysAttributeInfoButton;
